<template>
  <div class="animated fadeIn">
    <b-card>
      <vue-loading :active.sync="workingTimeSetupsTableProps.isLoading" :is-full-page="false"/>
      <vue-loading :active.sync="isLoadingDeleting" :is-full-page="false"/>
      <div slot="header">
        <b>Nastavitve delovnega časa</b>
        <div class="card-header-actions">
          <CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_workingTimeSetupsTableRefresh">
            <CIcon name="cil-loop-circular"/>
          </CLink>
          <CLink title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_workingTimeSetupsTableResetFilters">
            <CIcon name="cil-x"/>
          </CLink>
          <CLink title="Dodaj nastavitev delovnega časa" href="#" class="card-header-action btn-setting" @click.stop="click_workingTimeSetupCreate">
            <CIcon name="cil-plus"/>
          </CLink>
        </div>
      </div>

      <div class="table-filters-wrap">
        <div class="single-filter-wrap">
          <label for="search-filter">Iskanje zaposlenega ali razloga</label>
          <b-form-input
              v-model="workingTimeSetupsTableProps.inputFilter.search"
              type="text"
              id="search-filter"
              @input="workingTimeSetupsTableTextFilter_change"/>
        </div>
        <div class="single-filter-wrap">
          <label for="start-date-filter">Velja od</label>
          <b-form-input
              v-model="workingTimeSetupsTableProps.inputFilter.start_date"
              type="date"
              id="start-date-filter"
              @input="workingTimeSetupsTableTextFilter_change"/>
        </div>
        <div class="single-filter-wrap">
          <label for="end-date-filter">Velja do</label>
          <b-form-input
              v-model="workingTimeSetupsTableProps.inputFilter.end_date"
              type="date"
              id="end-date-filter"
              @input="workingTimeSetupsTableTextFilter_change"/>
        </div>
      </div>

      <b-table
          ref="workingTimeSetupsTable"
          responsive="sm"
          striped
          show-empty
          hover
          :empty-text="workingTimeSetupsTableProps.empty_text"
          :empty-filtered-text="workingTimeSetupsTableProps.empty_filtered_text"
          :fields="workingTimeSetupsTableProps.fields"
          :current-page="workingTimeSetupsTableProps.currentPage"
          :per-page="workingTimeSetupsTableProps.itemsPerPage"
          sort-by="id"
          :sort-desc="true"
          :items="workingTimeSetupsTable_items">
        <template v-slot:cell(user_name)="data"class="text-nowrap">
          {{ data.item.user_name ? `${data.item.user_name}` : 'Vsi zaposleni' }}
        </template>

        <template v-slot:cell(monday)="data">
          <div v-if="data.item.monday_enabled" class="text-nowrap">{{ formatTime(data.item.monday_start) }}-{{ formatTime(data.item.monday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(tuesday)="data">
          <div v-if="data.item.tuesday_enabled" class="text-nowrap">{{ formatTime(data.item.tuesday_start) }}-{{ formatTime(data.item.tuesday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(wednesday)="data">
          <div v-if="data.item.wednesday_enabled" class="text-nowrap">{{ formatTime(data.item.wednesday_start) }}-{{ formatTime(data.item.wednesday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(thursday)="data">
          <div v-if="data.item.thursday_enabled" class="text-nowrap">{{ formatTime(data.item.thursday_start) }}-{{ formatTime(data.item.thursday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(friday)="data">
          <div v-if="data.item.friday_enabled" class="text-nowrap">{{ formatTime(data.item.friday_start) }}-{{ formatTime(data.item.friday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(saturday)="data">
          <div v-if="data.item.saturday_enabled" class="text-nowrap">{{ formatTime(data.item.saturday_start) }}-{{ formatTime(data.item.saturday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(sunday)="data">
          <div v-if="data.item.sunday_enabled" class="text-nowrap">{{ formatTime(data.item.sunday_start) }}-{{ formatTime(data.item.sunday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>
        <template v-slot:cell(holiday)="data">
          <div v-if="data.item.holiday_enabled" class="text-nowrap">{{ formatTime(data.item.holiday_start) }}-{{ formatTime(data.item.holiday_end) }}</div>
          <div v-else class="text-muted">Ne dela</div>
        </template>

        <template v-slot:cell(effective_from)="data">
          <div v-if="data.item.effective_from" class="text-nowrap">{{ data.item.effective_from | viewDate }}</div>
          <div v-else class="text-nowrap">Trajno</div>
        </template>
        <template v-slot:cell(effective_to)="data">
          <div v-if="data.item.effective_to" class="text-nowrap">{{ data.item.effective_to | viewDate }}</div>
          <div v-else class="text-nowrap">Trajno</div>
        </template>
        <template v-slot:cell(actions)="data">
          <div>
            <b-button title="Uredi nastavitev delovnega časa" variant="primary" @click.stop="click_workingTimeSetupEdit(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-pencil"/>
            </b-button>
            <b-button title="Izbriši nastavitev delovnega časa" variant="danger" @click.stop="click_workingTimeSetupDelete(data.item)" size="sm" class="mr-2">
              <CIcon name="cil-trash"/>
            </b-button>
          </div>
        </template>
      </b-table>
      <nav>
        <b-row>
          <b-col>
            <b-pagination :total-rows="workingTimeSetupsTableProps.totalItems" :per-page="workingTimeSetupsTableProps.itemsPerPage" v-model="workingTimeSetupsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
          </b-col>
          <b-col cols=2>
            <a class="page-link rows_total float-right">Št. vrstic: {{ workingTimeSetupsTableProps.totalItems }}</a>
          </b-col>
          <b-col cols=1>
            <b-form-select v-model="workingTimeSetupsTableProps.itemsPerPage" :options="workingTimeSetupsTableProps.options_numRowsOnPage"></b-form-select>
          </b-col>
        </b-row>
      </nav>
    </b-card>
    <working-time-setup-create-edit-modal ref="workingTimeSetupCreateEditModal" @emit_workingTimeSetupCreatedOrEdited="emit_workingTimeSetupCreatedOrEdited"/>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import settings from '@/settings.js';
import { WORKING_TIME_SETUPS_LIST, WORKING_TIME_SETUP_DELETE } from "@/store/actions/workingTimeSetups";
import WorkingTimeSetupCreateEdit from "@/views/modals/WorkingTimeSetupCreateEdit.vue";

export default {
  name: 'WorkingTimeSetups',
  components: {
    'working-time-setup-create-edit-modal': WorkingTimeSetupCreateEdit
  },
  data () {
    return {
      workingTimeSetupsTableProps: {
        fields: [
          { key: 'id', label: 'Id', sortable: true, class: 'tdWorkingTimeSetupsId' },
          { key: 'user_name', label: 'Zaposleni', sortable: true, class: '' },

          { key: 'monday', label: 'PON', sortable: false, class: 'text-center' },
          { key: 'tuesday', label: 'TOR', sortable: false, class: 'text-center' },
          { key: 'wednesday', label: 'SRE', sortable: false, class: 'text-center' },
          { key: 'thursday', label: 'ČET', sortable: false, class: 'text-center' },
          { key: 'friday', label: 'PET', sortable: false, class: 'text-center' },
          { key: 'saturday', label: 'SOB', sortable: false, class: 'text-center' },
          { key: 'sunday', label: 'NED', sortable: false, class: 'text-center' },
          { key: 'holiday', label: 'PRAZNIK', sortable: false, class: 'text-center' },

          { key: 'effective_from', label: 'Velja od', sortable: true, class: 'text-center' },
          { key: 'effective_to', label: 'Velja do', sortable: true, class: 'text-center' },
          { key: 'reason', label: 'Razlog', sortable: false, class: '' },
          { key: 'actions', label: '#', sortable: false, class: 'tdWorkingTimeSetupsActions' },
        ],
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
        isLoading: false,
        options_numRowsOnPage: [
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 200, text: '200' },
          { value: 1000, text: '1000' }
        ],
        empty_text: '',
        empty_filtered_text: 'Ni zadetkov',
        inputFilter: {
          search: null,
          start_date: null,
          end_date: null
        },
        textFilterTimeout: null,
        errorText: ''
      },
      isLoadingDeleting: false
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    formatTime(time) {
      if (!time) return '';
      // If time is in HH:MM:SS format, extract HH:MM
      return time.substring(0, 5);
    },
    click_workingTimeSetupCreate: function () {
      let modalInput = {
        mode: 1, // create
        modalWorkingTimeSetup: null
      }
      this.$refs.workingTimeSetupCreateEditModal.showModal(modalInput);
    },
    click_workingTimeSetupEdit: function (data) {
      let modalInput = {
        mode: 2, // edit
        modalWorkingTimeSetup: data
      }
      this.$refs.workingTimeSetupCreateEditModal.showModal(modalInput);
    },
    click_workingTimeSetupDelete: function (data) {
      const userName = data.user_name ? data.user_name : 'Vsi zaposleni';
      this.$bvModal.msgBoxConfirm('Želite izbrisati nastavitev delovnega časa za ' + userName + ' (#' + data.id + ')?', {
        title: 'Potrdite izbris nastavitve',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DA',
        cancelTitle: 'NE',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value === true) {
          this.isLoadingDeleting = true;
          this.$store.dispatch(WORKING_TIME_SETUP_DELETE, data.id)
              .then((responseData) => {
                this.isLoadingDeleting = false;
                this.$refs.toastr.s('Nastavitev delovnega časa (#' + data.id + ') uspešno izbrisana.');
                this.$refs.workingTimeSetupsTable.refresh();
              })
              .catch(error => {
                this.isLoadingDeleting = false;
                console.error(error);
                if(error.response && error.response.data && error.response.data.code) {
                  this.$refs.toastr.e('Napaka pri brisanju! (' + error.response.data.code + ')');
                } else {
                  this.$refs.toastr.e('Napaka pri brisanju! Prosimo poizkusite kasneje.');
                }
              });
        }
      }).catch(err => {
        console.error(err);
      })
    },
    click_workingTimeSetupsTableRefresh: function () {
      this.$refs.workingTimeSetupsTable.refresh();
    },
    click_workingTimeSetupsTableResetFilters: function () {
      this.workingTimeSetupsTableProps.inputFilter.search = null;
      this.workingTimeSetupsTableProps.inputFilter.start_date = null;
      this.workingTimeSetupsTableProps.inputFilter.end_date = null;
      this.$refs.workingTimeSetupsTable.refresh();
    },
    emit_workingTimeSetupCreatedOrEdited: function (data) {
      if (data.message === 'created') {
        this.$refs.toastr.s('Nastavitev delovnega časa uspešno dodana.');
      } else if (data.message === 'edited') {
        this.$refs.toastr.s('Nastavitev delovnega časa uspešno urejena.');
      } else {
        this.$refs.toastr.e('Neznan odziv strežnika.');
      }
      this.$refs.workingTimeSetupsTable.refresh();
    },
    workingTimeSetupsTable_items: function (ctx) {
      this.workingTimeSetupsTableProps.isLoading = true;
      return this.$store.dispatch(WORKING_TIME_SETUPS_LIST, { ctx: ctx, tableProps: this.workingTimeSetupsTableProps })
          .then((responseData) => {
            this.workingTimeSetupsTableProps.isLoading = false;
            this.workingTimeSetupsTableProps.items = responseData.workingTimeSetups.data;
            this.workingTimeSetupsTableProps.totalItems = responseData.workingTimeSetups.total;
            this.workingTimeSetupsTableProps.empty_text = 'Ni vnosov';
            return responseData.workingTimeSetups.data;
          })
          .catch(error => {
            this.workingTimeSetupsTableProps.isLoading = false;
            this.workingTimeSetupsTableProps.items = [];
            this.workingTimeSetupsTableProps.totalItems = 0;
            this.workingTimeSetupsTableProps.empty_text = 'Napaka pri pridobivanju podatkov nastavitev delovnega časa';
            console.log(error);
            return [];
          });
    },
    workingTimeSetupsTableTextFilter_change: function (value) {
      if (this.workingTimeSetupsTableProps.textFilterTimeout !== null) {
        clearTimeout(this.workingTimeSetupsTableProps.textFilterTimeout);
      }
      this.workingTimeSetupsTableProps.textFilterTimeout = setTimeout(() => {
        this.$refs.workingTimeSetupsTable.refresh();
      }, settings.filterTimeoutLength);
    },
  }
}
</script>
<style scoped>
.table-responsive-sm {
  margin-bottom: 0;
}
.pagination {
  margin-left: 1rem;
  margin-right: 1rem;
}
.page-link.rows_total {
  text-align: center;
  border-radius: 5px;
  width: 120px;
}
.table-filters-wrap {
  margin-bottom: 15px;
  float: left;
}
.single-filter-wrap {
  width: 250px;
  float: left;
  margin-right: 15px;
}
</style>

<style>
.tdWorkingTimeSetupsId {
  width: 80px;
}
.tdWorkingTimeSetupsActions {
  width: 120px;
}
</style>
